export const roles = [
  "Admin",
  "Manager",
  "General Manager",
  "Operations Manager",
  "IT",
  "Salesperson",
  "Window Door Manager",
  "Window Door Technician",
  "Fleet Manager",
  "Driver",
  "Inside Sales",
  "Outside Sales",
  "Executive Team",
  "Area Manager",
  "Office",
  "Web Lead Manager",
  "Cabinet Team",
  "SBCF Admin",
  "SBCF Assigner",
  "SBCF Team",
  "RFQ Tester",
  "PCW Admin",
  "Mill Admin",
  "Safety Manager",
];
